export const SET_CURRENT_RESTAURANT = 'SET_CURRENT_RESTAURANT';

export const GET_RESTAURANT_MEAL_SCHEDULE = 'GET_RESTAURANT_MEAL_SCHEDULE';
export const GET_RESTAURANT_MEAL_SCHEDULE_SUCCESS = 'GET_RESTAURANT_MEAL_SCHEDULE_SUCCESS';
export const GET_RESTAURANT_MEAL_SCHEDULE_FAILED = 'GET_RESTAURANT_MEAL_SCHEDULE_FAILED';

export const GET_RESTAURANT_ORDER = 'GET_RESTAURANT_ORDER';
export const GET_RESTAURANT_ORDER_SUCCESS = 'GET_RESTAURANT_ORDER_SUCCESS';
export const GET_RESTAURANT_ORDER_FAILED = 'GET_RESTAURANT_ORDER_FAILED';

export const GET_RESTURANT_ORDER_DETAILS = 'GET_RESTAURANT_ORDER_DETAILS';
export const GET_RESTURANT_ORDER_DETAILS_SUCCESS = 'GET_RESTAURANT_ORDER_DETAILS_SUCCESS';
export const GET_RESTURANT_ORDER_DETAILS_FAILED = 'GET_RESTAURANT_ORDER_DETAILS_FAILED';

export const ADD_RESTAURANT_MEAL = 'ADD_RESTAURANT_MEAL';
export const ADD_RESTAURANT_MEAL_SUCCESS = 'ADD_RESTAURANT_MEAL_SUCCESS';
export const ADD_RESTAURANT_MEAL_FAILURE = 'ADD_RESTAURANT_MEAL_FAILURE';

export const GET_RESTAURANT_MEALS = 'GET_RESTAURANT_MEALS';
export const GET_RESTAURANT_MEALS_SUCCESS = 'GET_RESTAURANT_MEALS_SUCCESS';
export const GET_RESTAURANT_MEALS_FAILURE = 'GET_RESTAURANT_MEALS_FAILURE';

export const SET_SELECTED_DAY_FOR_MEAL_SCHEDULE = 'SET_SELECTED_DAY_FOR_MEAL_SCHEDULE';
export const resetToInitialState = 'RESET_TO_INITIAL_STATE';
